import React from 'react';
import styled from 'styled-components/macro';
import { SVGIcon } from '@yme/atoms/svg-icon';
export const ExpandingBlockStyled = styled.div `
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  gap: 8px;
  width: 100%;

  padding-top: ${({ isExpanded }) => (isExpanded ? '2px;' : '0px;')};
  height: ${({ isExpanded, heightContent }) => isExpanded ? `${heightContent}px;` : '20px;'};

  transition: all 0.5s ease-out;
`;
export const ContentWrapper = styled.div `
  overflow: hidden;

  ${({ textColor }) => textColor && `color: ${textColor};`}
  direction: ${({ isRightToLeft }) => (isRightToLeft ? 'rtl' : 'ltr')};
  order: ${({ order }) => order};

  ${({ isExpanded }) => !isExpanded &&
    `
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    `}
`;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const SVGIconStyled = styled(({ isExpanded, isRightToLeft, ...props }) => (React.createElement(SVGIcon, { ...props }))) `
  ${({ isExpanded }) => (isExpanded ? 'transform: rotate(180deg);' : 'transform: rotate(0deg);')};

  order: ${({ order }) => order};
  ${({ isRightToLeft }) => (isRightToLeft ? 'margin-right: auto;' : 'margin-left: auto;')};

  cursor: pointer;
`;
